<template>
  <div class="anCore-app-root" :class="{ 'anCore-bigPage': collapsed }">
    <header class="anCore-navbar-wrapper">
      <div class="anCore-navbar anCore-navbar-fixed-top">
        <div class="container-fluid">
          <span class="anCore-navbar-logo" style="cursor: default;">
            <span id="anCore-appTitle" class="hidden-xs">{{ appTitle }}</span>
            <span class="visible-xs-inline-block" id="anCore-minTabTitle" style="width: calc(100% - 28px);">
              {{ activeTabTitle }}
            </span>
          </span>
          <span class="anCore-navbar-logo anCore-navbar-slogan hidden-xs" id="anCore-appVersion">{{ appVersion }}</span>

          <nav id="anCore-userbar" class="anCore-navbar-nav anCore-navbar-userbar hidden-xs">
            <ul>
              <li id="anCore-user-depRole">{{ userDeptLabel }}</li>
              <li class="anCore-dropDown anCore-dropDown-hover" @click.stop>
                <a href="javascript:;" class="anCore-dropDown-title" @click.prevent="userMenuOpen = !userMenuOpen">
                  <span id="anCore-user-name">{{ user.xm || '用户' }}</span>
                  <i class="iconfont icon-moreunfold" />
                </a>
                <ul v-show="userMenuOpen" class="anCore-dropDown-menu">
                  <li><a href="javascript:;" @click.prevent="goProfile">个人信息</a></li>
                  <li><a href="javascript:;" @click.prevent="logout">退出</a></li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>

    <aside class="anCore-aside" id="anCore-asideMenu">
      <div class="anCore-menuDropDown">
        <dl v-for="g in visibleGroups" :key="g.group">
          <dt
            :class="{ 'anCore-selected': openGroups[g.group] }"
            @click="toggleGroup(g.group)"
          >
            <span>
              <i :class="g.icon || 'iconfont icon-category'" />
              <label>{{ g.group }}</label>
            </span>
            <i class="iconfont icon-moreunfold anCore-menuDropDown-arrow" />
          </dt>
          <dd :class="{ 'anCore-dd-open': openGroups[g.group] }">
            <ul>
              <li
                v-for="item in g.items"
                :key="item.path"
                :class="{ 'anCore-current': isMenuActive(item.path) }"
              >
                <a href="javascript:;" @mousedown.prevent @click.prevent="openMenu(item)">
                  <span>{{ item.text }}</span>
                  <em
                    v-if="item.path === '/todo' && todoBadge > 0"
                    class="yn-todo-badge"
                  >{{ todoBadge > 99 ? '99+' : todoBadge }}</em>
                </a>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </aside>

    <div class="anCore-dislpayArrow hidden-xs">
      <a
        href="javascript:;"
        id="anCore-dislpayArrowBar"
        :class="{ 'anCore-open': collapsed }"
        @click.prevent="collapsed = !collapsed"
      />
    </div>

    <section class="anCore-mainContent-box">
      <div id="anCore-tabNav" class="anCore-tabNav hidden-xs">
        <div class="anCore-tabNav-wp">
          <ul id="anCore-menuTab-list" class="anCore-acrossTab" :style="{ left: tabOffset + 'px' }">
            <li
              v-for="tab in tabs"
              :key="tab.path"
              :class="{ 'anCore-active': tab.path === activeTabPath }"
              @click="activateTab(tab)"
              @contextmenu.prevent="onTabContext(tab, $event)"
            >
              <span :title="tab.title">{{ tab.title }}</span>
              <i v-if="!tab.affix" @click.stop="closeTab(tab)" />
              <em />
            </li>
          </ul>
        </div>
        <div class="anCore-tabNav-more anCore-btn-group">
          <a id="anCore-tabNav-prev" class="anCore-btn anCore-btn-default" href="javascript:;" @click.prevent="scrollTabs(-120)">
            <i class="iconfont icon-back" style="font-size: 12px;" />
          </a>
          <a id="anCore-tabNav-next" class="anCore-btn anCore-btn-default" href="javascript:;" @click.prevent="scrollTabs(120)">
            <i class="iconfont icon-more" style="font-size: 12px;" />
          </a>
        </div>
      </div>

      <div id="anCore-tabPage-box" class="anCore-mainContent">
        <div class="anCore-tabPage" style="display:block;height:100%">
          <!-- 对齐 Ivan：body 不定 overflow:auto（否则采样管理等左右分栏会多出第三条滚动条）。
               定高页 meta.fillHeight → overflow:hidden，由页内左右栏自滚；
               表单页默认 visible，超高由 .anCore-mainContent 的 overflow:auto 承接。 -->
          <div
            class="container-fluid anCore-tabPage-body"
            :style="tabPageBodyStyle"
          >
            <keep-alive :include="keepAliveNames">
              <router-view :key="$route.path" />
            </keep-alive>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { IVAN_MENU_GROUPS } from '@/config/ivanMenus'
import { canSeeMenuItem } from '@/utils/ivanMenuAuth'
import { subscribeTodoSync } from '@/utils/todoSync'

const AFFIX_TAB = { path: '/home', title: '首页', affix: true }

/** 与 Ivan menu.json / iconfont 一致；icon-manage 不存在会导致「系统管理」无图标、文字错位 */
const GROUP_ICONS = {
  业务流程: 'iconfont icon-category',
  查询统计: 'iconfont icon-search',
  资源管理: 'iconfont icon-form',
  参数设置: 'iconfont icon-color',
  系统管理: 'iconfont icon-set'
}

export default {
  name: 'Layout',
  data() {
    return {
      collapsed: false,
      userMenuOpen: false,
      tabOffset: 0,
      openGroups: { 业务流程: true },
      tabs: [{ ...AFFIX_TAB }],
      appTitle: '远诺检测项目管理系统',
      appVersion: '1.0',
      todoBadge: 0
    }
  },
  computed: {
    user() {
      try {
        return JSON.parse(sessionStorage.getItem('yn_user') || '{}')
      } catch (e) {
        return {}
      }
    },
    /** 对齐 8072：顶栏显示部门（综合部），不是角色名（任务分配人） */
    userDeptLabel() {
      const u = this.user
      return u.dept_label || u.bmmc || u.deptLabel || ''
    },
    visibleGroups() {
      return IVAN_MENU_GROUPS.map(g => ({
        group: g.group,
        icon: GROUP_ICONS[g.group] || 'iconfont icon-category',
        items: g.items.filter(item => this.canSee(item))
      })).filter(g => g.items.length)
    },
    activeTabPath() {
      const p = this.$route.path
      if (p === '/dashboard') return '/home'
      return p
    },
    activeTabTitle() {
      const t = this.tabs.find(x => x.path === this.activeTabPath)
      return (t && t.title) || '首页'
    },
    keepAliveNames() {
      return ['HomePortal', 'TodoBox', 'EntrustFlow', 'RoutineEntrustFlow', 'SelfSendEntrustFlow', 'EntrustAudit', 'RoutinePickPlan']
    },
    /** 左右分栏/满高页：锁死外层滚动，避免与页内滚动条叠成三条 */
    tabPageBodyStyle() {
      const fill = !!(this.$route.meta && this.$route.meta.fillHeight)
      return {
        height: '100%',
        overflow: fill ? 'hidden' : 'visible',
        padding: '10px 15px 10px 25px',
        boxSizing: 'border-box'
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.ensureTab(to)
        this.userMenuOpen = false
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.onDocClick)
    this._unsubTodo = subscribeTodoSync((p) => {
      this.todoBadge = Number(p.count) || 0
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick)
    if (typeof this._unsubTodo === 'function') {
      this._unsubTodo()
      this._unsubTodo = null
    }
  },
  methods: {
    onDocClick() {
      this.userMenuOpen = false
    },
    canSee(item) {
      // 对齐 8072 GetMenuConfig：按 Ivan 角色 AuthorityList 裁剪
      return canSeeMenuItem(item, this.user)
    },
    toggleGroup(name) {
      this.$set(this.openGroups, name, !this.openGroups[name])
    },
    isMenuActive(path) {
      const p = this.$route.path
      if (path === '/home') return p === '/home' || p === '/dashboard' || p === '/'
      if (path === '/todo') return p === '/todo'
      // 分析管理勿高亮样品交接 / 理化队列
      if (path === '/soil') return p === '/soil'
      if (path === '/task-track') return p === '/task-track'
      return p === path || p.startsWith(path + '/')
    },
    openMenu(item) {
      if (this.$route.path !== item.path) this.$router.push(item.path).catch(() => {})
    },
    tabTitleFor(route) {
      const path = route.path === '/dashboard' ? '/home' : route.path
      if (path === '/home') return '首页'
      if (path === '/todo') return '待我处理的'
      if (path.startsWith('/entrust/new')) return '委托发起流程(新建)'
      if (path.startsWith('/entrust/')) return '委托发起流程'
      if (path.startsWith('/routine/new')) return '周期任务执行(新建)'
      if (path.startsWith('/routine/audit/')) return '委托审核'
      if (path.startsWith('/routine/plan/')) return '周期任务安排'
      if (path.startsWith('/routine/') && path !== '/routine-admin' && path !== '/routine-plans' && path !== '/routine-query') {
        return '周期任务执行'
      }
      if (path.startsWith('/self-send/new')) return '来样检测业务流程(新建)'
      if (path.startsWith('/self-send/')) return '来样检测业务流程'
      return (route.meta && route.meta.title) || path
    },
    ensureTab(route) {
      if (!route || route.path === '/login') return
      const path = route.path === '/dashboard' ? '/home' : route.path
      const title = this.tabTitleFor({ ...route, path })
      const exist = this.tabs.find(t => t.path === path)
      if (exist) {
        exist.title = title
        return
      }
      this.tabs.push({ path, title, affix: path === '/home' })
    },
    activateTab(tab) {
      if (this.$route.path !== tab.path) this.$router.push(tab.path).catch(() => {})
    },
    closeTab(tab) {
      if (tab.affix) return
      const idx = this.tabs.findIndex(t => t.path === tab.path)
      if (idx < 0) return
      const wasActive = this.activeTabPath === tab.path
      this.tabs.splice(idx, 1)
      if (wasActive) {
        const next = this.tabs[Math.max(0, idx - 1)] || AFFIX_TAB
        this.$router.push(next.path).catch(() => {})
      }
    },
    onTabContext() {},
    scrollTabs(delta) {
      this.tabOffset = Math.min(0, this.tabOffset - delta)
    },
    goProfile() {
      this.userMenuOpen = false
      this.$router.push('/profile')
    },
    logout() {
      sessionStorage.removeItem('yn_user')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.anCore-app-root {
  height: 100%;
  position: relative;
}
.anCore-dropDown-menu {
  position: absolute;
  right: 0;
  top: 36px;
  background: #fff;
  border: 1px solid #ddd;
  min-width: 120px;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0,0,0,.12);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  display: block;
}
.anCore-dropDown-menu a {
  display: block;
  padding: 6px 14px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
}
.anCore-dropDown-menu a:hover {
  background: #f5f5f5;
  color: #148cf1;
}
.anCore-dropDown {
  position: relative;
}
#anCore-menuTab-list {
  position: relative;
  white-space: nowrap;
  transition: left 0.2s;
}
.yn-todo-badge {
  display: inline-block;
  min-width: 16px;
  height: 16px;
  margin-left: 6px;
  padding: 0 4px;
  border-radius: 8px;
  background: #e6a23c;
  color: #fff;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  font-style: normal;
  vertical-align: middle;
}
</style>

<style>
/* 侧栏菜单：去掉点击/焦点黑框，选中保持蓝字清晰 */
.anCore-aside .anCore-menuDropDown a,
.anCore-aside .anCore-menuDropDown a:hover,
.anCore-aside .anCore-menuDropDown a:focus,
.anCore-aside .anCore-menuDropDown a:focus-visible,
.anCore-aside .anCore-menuDropDown a:active {
  outline: none !important;
  box-shadow: none !important;
  -webkit-tap-highlight-color: transparent;
}
.anCore-aside .anCore-menuDropDown li.anCore-current,
.anCore-aside .anCore-menuDropDown li.anCore-current > a,
.anCore-aside .anCore-menuDropDown .anCore-current > a:hover,
.anCore-aside .anCore-menuDropDown .anCore-current > a:focus,
.anCore-aside .anCore-menuDropDown .anCore-current > a:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
  color: #148cf1 !important;
  background-color: rgba(20, 140, 241, 0.08);
}
</style>
